import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router'; // Import Routes for type safety
import { QuotationListComponent } from './quotation/quotation-list/quotation-list.component';
import { QuotationDashboardComponent } from './quotation/quotation-dashboard/quotation-dashboard.component';
import { CustomerListComponent } from './customer/customer-list/customer-list.component';
import { SharedModule } from '../shared/shared.module';
import { CalendarModule } from 'primeng/calendar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { QuotationFormDialogComponent } from './quotation/quotation-form-dialog/quotation-form-dialog.component';
import { MatTableModule } from '@angular/material/table';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { CreateCustomerDialogComponent } from './customer/create-customer-dialog/create-customer-dialog.component';
import { TagModule } from 'primeng/tag';
import { ChartModule } from 'primeng/chart';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TooltipModule } from 'primeng/tooltip';
import { SelectButtonModule } from 'primeng/selectbutton';
import { MultiSelectModule } from 'primeng/multiselect';
import { QuotationTopHeaderComponent } from './quotation/quotation-top-header/quotation-top-header.component';
import { QuotationHeaderComponent } from './layout/quotation-header/quotation-header.component';
import { QuotationFooterComponent } from './layout/quotation-footer/quotation-footer.component';
import { SidebarModule } from 'primeng/sidebar';
import { ChipModule } from 'primeng/chip';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { MessagesModule } from 'primeng/messages';
import { FileUploadModule } from 'primeng/fileupload';
import { QuotationRegisterComponent } from './auth/quotation-register/quotation-register.component';
import { QuotationLoginComponent } from './auth/quotation-login/quotation-login.component';
import { AuthGuard } from './auth/auth.guard';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ButtonModule } from 'primeng/button';
import { DashboardChartDialogComponent } from './quotation/dashboard-chart-dialog/dashboard-chart-dialog.component';
import { DueQuotationDialogComponent } from './quotation/due-quotation-dialog/due-quotation-dialog.component';
import { SliderModule } from 'primeng/slider';
import { MessageModule } from 'primeng/message';
import { QuotationStatusComponent } from './quotation/quotation-status/quotation-status.component';
import { QuotationStatusDialogComponent } from './quotation/quotation-status-dialog/quotation-status-dialog.component';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { StepsModule } from 'primeng/steps';
import { TimelineModule } from 'primeng/timeline';
import { DialogModule } from 'primeng/dialog';
import { QuotationWeeklyDashboardComponent } from './quotation/quotation-weekly-dashboard/quotation-weekly-dashboard.component';
import { WeeklyChartDialogComponent } from './quotation/weekly-chart-dialog/weekly-chart-dialog.component';
import { LostOrderComponent } from './quotation/lost-order/lost-order.component';
import { PanelModule } from 'primeng/panel';
import { SplitButtonModule } from 'primeng/splitbutton';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { OrderNumberGenarateComponent } from './quotation/order-number-genarate/order-number-genarate.component';
import { ToolbarModule } from 'primeng/toolbar';
import { SettingsComponent } from './settings/settings.component';
import { TreeTableModule } from 'primeng/treetable';
// Define the routes
const quotationRoutes: Routes = [
  {
    path: '',
    redirectTo: 'auth/login', // Default route redirects to login
    pathMatch: 'full'
  },
  {
    path: 'auth',
    children: [
      {
        path: '',
        redirectTo: 'login', // Default auth route redirects to login
        pathMatch: 'full'
        ,
        data: { hideSideMenu: true } // Add this
      },
      {
        path: 'login',
        component: QuotationLoginComponent // Login route, publicly accessible
        ,
        data: { hideSideMenu: true } // Add this
      },
      {
        path: 'register',
        component: QuotationRegisterComponent // Register route, publicly accessible
        ,
        data: { hideSideMenu: true } // Add this
      }
    ]
  },
  {
    path: 'quotation-list',
    component: QuotationListComponent,
    data: { hideSideMenu: true }, // Add this
    canActivate: [AuthGuard] // Protect this route
  },
  {
    path: 'quotation-dashboard',
    component: QuotationDashboardComponent,
    // data: { hideSideMenu: true }, // Add this
    canActivate: [AuthGuard] // Protect this route
  },
  {
    path: 'customer-list',
    component: CustomerListComponent,
    data: { hideSideMenu: true }, // Add this
    canActivate: [AuthGuard] // Protect this route
  },
  {
    path: 'quotation-status',
    component: QuotationStatusComponent,
    data: { hideSideMenu: true }, // Add this
    canActivate: [AuthGuard] // Protect this route
  },
  {
    path: 'quotation-weekly-dashboard',
    component: QuotationWeeklyDashboardComponent,
    data: { hideSideMenu: true }, // Add this
    canActivate: [AuthGuard] // Protect this route
  },
  {
    path: 'quotation-manage-kikf1',
    component: LostOrderComponent,
    data: { hideSideMenu: true }, // Add this
    canActivate: [AuthGuard] // Protect this route
  },
  {
    path: 'Order-number-genarate',
    component: OrderNumberGenarateComponent,
    data: { hideSideMenu: true }, // Add this
    canActivate: [AuthGuard] // Protect this route
  },
  {
    path: 'settings-link',
    component: SettingsComponent,
    data: { hideSideMenu: true }, // Add this
    canActivate: [AuthGuard] // Protect this route
  }
];

@NgModule({
  declarations: [
    QuotationFormDialogComponent,
    QuotationListComponent,
    QuotationDashboardComponent,
    CustomerListComponent,
    CreateCustomerDialogComponent,
    QuotationHeaderComponent,
    QuotationFooterComponent,
    QuotationTopHeaderComponent,
    QuotationRegisterComponent,
    QuotationLoginComponent,
    DashboardChartDialogComponent,
    DueQuotationDialogComponent,
    QuotationStatusComponent,
    QuotationStatusDialogComponent,
    QuotationWeeklyDashboardComponent,
    WeeklyChartDialogComponent,
    LostOrderComponent,
    OrderNumberGenarateComponent,
    SettingsComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(quotationRoutes), // Use the defined routes
    SharedModule,
    CalendarModule,
    MatTableModule,
    MatDialogModule,
    MatFormFieldModule,
    MatProgressBarModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonModule,
    MatIconModule,
    TagModule,
    ChartModule,
    ProgressBarModule,
    ProgressSpinnerModule,
    TooltipModule,
    SelectButtonModule,
    MultiSelectModule,
    ButtonModule,
    SidebarModule,
    InputSwitchModule,
    ChipModule,
    AutoCompleteModule,
    StepsModule,
    MessagesModule,
    FileUploadModule,
    SliderModule,
    MessageModule,
    TableModule,
    InputTextModule,
    TimelineModule,
    DialogModule,
    PanelModule,
    SplitButtonModule,
    ToggleButtonModule,
    ToolbarModule,
    TreeTableModule
  ]
})
export class QuotationPartModule { }